// noinspection SpellCheckingInspection
import {Notifications as MantineNotifications} from "@mantine/notifications";
import classes from "./Notifications.module.css";
import {IconCheck, IconCircleXFilled} from "@tabler/icons-react";

type SimplePayload = {
    title: string;
    message: string;
}

/**
 * Static class with predefined notifications.
 * To use this you need to have notification container.
 * @author Kacper Faber
 * @since 0.1.0
 */
// noinspection JSUnusedGlobalSymbols
class Notifications {
    /**
     * @example
     * Nie udało się zalogować
     * -
     * @author Kacper Faber
     * @since 0.1.0
     */
    static onLoginFailed() {
        MantineNotifications.show({
            title: 'Nie udało się zalogować',
            message: 'test',
            icon: <IconCircleXFilled/>,
            color: 'red',
            bg: 'red',
            classNames: {
                root: classes.fail,
                title: classes.title,
                description: classes.description,
                closeButton: classes.closeButton
            },
        });
    }

    static onUpdateFailed() {
        MantineNotifications.show({
            title: 'Nie udało się zaktualizować zasobu',
            message: 'Jeśli problem nie ustąpi, proszę skontaktować się z administratorem',
            icon: <IconCircleXFilled/>,
            color: 'red',
            bg: 'red',
            classNames: {
                root: classes.fail,
                title: classes.title,
                description: classes.description,
                closeButton: classes.closeButton
            },
        });
    }

    static onUpdateSuccess() {
        MantineNotifications.show({
            title: 'Zaktualizowano!',
            message: '',
            icon: <IconCheck/>,
            color: 'green',
            bg: 'green',
            classNames: {
                root: classes.success,
                title: classes.title,
                description: classes.description,
                closeButton: classes.closeButton
            },
        });
    }

    /**
     * Show custom error.
     * @since 0.1.9
     * @author Kacper Faber
     */
    static customError(payload: SimplePayload) {
        MantineNotifications.show({
            ...payload,
            bg: 'red',
            color: 'red',
            icon: <IconCircleXFilled/>,
            classNames: {
                root: classes.fail,
                title: classes.title,
                description: classes.description,
                closeButton: classes.closeButton
            },
        })
    }

    /**
     * @example
     * Zalogowano!
     * -
     * @author Kacper Faber
     * @since 0.1.0
     */
    static onLoginSuccess() {
        MantineNotifications.show({
            title: 'Zalogowano!',
            message: '',
            bg: 'green',
            color: 'green',
            classNames: {
                root: classes.success,
                title: classes.title,
                description: classes.description,
                closeButton: classes.closeButton
            }
        });
    }

    /**
     * @example
     * Usunięto!
     * Zasób został usunięty z bazy danych
     * @author Kacper Faber
     * @since 0.1.0
     */
    static onDeleteSuccess() {
        MantineNotifications.show({
            title: 'Usunięto!',
            message: 'Zasób został usunięty z bazy danych',
            bg: 'green',
            color: 'green',
            classNames: {
                root: classes.success,
                title: classes.title,
                description: classes.description,
                closeButton: classes.closeButton
            }
        });
    }

    static onCreateSuccess() {
        MantineNotifications.show({
            title: 'Utworzono!',
            message: 'Zasób został utworzony',
            bg: 'green',
            color: 'green',
            classNames: {
                root: classes.success,
                title: classes.title,
                description: classes.description,
                closeButton: classes.closeButton
            }
        });
    }

    static onCreateFailed() {
        MantineNotifications.show({
            title: 'Nie udało się utworzyć zasobu',
            message: '',
            bg: 'red',
            color: 'red',
            icon: <IconCircleXFilled/>,
            classNames: {
                root: classes.fail,
                title: classes.title,
                description: classes.description,
                closeButton: classes.closeButton
            },
        })
    }

    /**
     * @example
     * Nie można usunąć zasobu.
     * Jeśli problem nie ustąpi, proszę skontaktować się z administratorem
     * @author Kacper Faber
     * @since 0.1.0
     */
    static onDeleteFailed() {
        MantineNotifications.show({
            title: 'Nie można usunąć zasobu.',
            message: 'Jeśli problem nie ustąpi, proszę skontaktować się z administratorem',
            bg: 'red',
            color: 'red',
            icon: <IconCircleXFilled/>,
            classNames: {
                root: classes.fail,
                title: classes.title,
                description: classes.description,
                closeButton: classes.closeButton
            },
        });
    }

    /**
     * @author Kacper Faber
     * @since 0.1.1
     */
    static onLogoutSuccess() {
        MantineNotifications.show({
            title: 'Wylogowano!',
            message: '',
            bg: 'green',
            color: 'green',
            classNames: {
                root: classes.success,
                title: classes.title,
                description: classes.description,
                closeButton: classes.closeButton
            }
        });
    }

    /**
     * @author Kacper Faber
     * @since 0.1.1
     */
    static onLogoutFailed() {
        MantineNotifications.show({
            title: 'Nie udało się wylogować',
            message: 'Jeśli problem nie ustąpi, proszę skontaktować się z administratorem',
            bg: 'red',
            color: 'red',
            classNames: {
                root: classes.fail,
                title: classes.title,
                description: classes.description,
                closeButton: classes.closeButton
            }
        });
    }

    /**
     * Nie udało się pobrać danych
     * @author Kacper Faber
     * @since 0.1.4
     */
    static onFetchError() {
        MantineNotifications.show({
            title: 'Nie udało się pobrać danych',
            message: 'Jeśli problem nie ustąpi, proszę skontaktować się z administratorem.',
            bg: 'red',
            color: 'red',
           classNames: {
                root: classes.failed,
                title: classes.title,
                description: classes.description,
                closeButton: classes.closeButton
            }
        });
    }
}

export default Notifications;